import "../assets/css/WifiForm.css";
import { useState, useEffect } from "react";
import { RxCross1 } from "react-icons/rx"; 
import { useNavigate } from "react-router-dom";
import { API_URL } from "../config";

function WifiForm() {
  const navigate = useNavigate();
  const [nom, setNom] = useState("");
  const [prenom, setPrenom] = useState("");
  const [emailVisiteur, setEmailVisiteur] = useState("");
  const [duree, setDuree] = useState(1);
  const [loading, setLoading] = useState(false);
  const [voucher, setVoucher] = useState(null);
  const [emailLoading, setEmailLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [quantite, setQuantite] = useState(1);

  const [sites, setSites] = useState([]);
  const [selectedSite, setSelectedSite] = useState("");

  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showHelp, setShowHelp] = useState(false);
  
  const fetchSites = async () => {
    try {
      const response = await fetch(`${API_URL}/api/user/sites`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });

      /* à enlever apres.. vérification pour les entreprise ayant plusieurs sites (ex : Aktisea)*/
      if (response.ok) {
        const data = await response.json();
        //console.log("Sites reçus :", data);
        setSites(data);

        //Select the first default site if one exists.
        if (data.length > 0) {
          setSelectedSite(data[0].id);
        }
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des sites:", error);
    }
  };

  // Security: Redirect if no token is present on load
  useEffect(() => {
    const t = localStorage.getItem("token");
    if (!t) {
      navigate("/");
      return;
    }
    // Load the Site associated with the user's company
    fetchSites();
  }, [navigate]);

  const getUsername = () => {
    const t = localStorage.getItem("token"); // Read the token 
    if (!t) return "Utilisateur";
    try {
      const payload = JSON.parse(atob(t.split(".")[1]));
      return payload.username || "Utilisateur";
    } catch { return "Utilisateur"; }
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/");
  };

  const handleSubmit = async () => {
  if (!nom || !prenom || !duree) {
    alert("Veuillez remplir tous les champs.");
    return;
  }

  const currentToken = localStorage.getItem("token");
  if (!currentToken) {
    alert("Votre session a expiré. Veuillez vous reconnecter.");
    navigate("/");
    return;
  }

  setLoading(true);

  try {
    const response = await fetch(`${API_URL}/api/vouchers/create`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${currentToken}`
      },
      body: JSON.stringify({ nom, prenom, duree, siteId: selectedSite, quantite: parseInt(quantite) })
    });

    if (response.ok) {
      const data = await response.json();
      // Gère un ou plusieurs vouchers
      setVoucher({ cles: data.cles, nom, prenom, duree, quantite: parseInt(quantite) });
      setNom("");
      setPrenom("");
      setEmailVisiteur("");
      setDuree(1);
      setQuantite(1);
      setEmailSent(false);
    } else {
      if (response.status === 401) {
        localStorage.removeItem("token");
        alert("Session expirée, veuillez vous reconnecter.");
        navigate("/");
      } else {
        const errorData = await response.json();
        alert("Erreur : " + (errorData.error || errorData.message || "Erreur serveur"));
      }
    }
  } catch (error) {
    alert("Erreur réseau.");
  } finally {
    setLoading(false);
  }
};

  const handleSendEmail = async () => {
    /*const token = localStorage.getItem("token");*/
    const currentToken = localStorage.getItem("token");
    setEmailLoading(true);

    try {
      const response = await fetch(`${API_URL}/api/vouchers/send-email`, {  
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${currentToken}`
        },
        body: JSON.stringify({
          cles: voucher.cles,         
          cle: voucher.cles ? voucher.cles[0] : voucher.cle,  
          nom: voucher.nom,
          prenom: voucher.prenom,
          duree: voucher.duree,
          email: emailVisiteur
        })
      });

      if (response.ok) {
        setEmailSent(true);
      } else {
        alert("Erreur lors de l'envoi de l'email.");
      }
    } catch (error) {
      alert("Erreur réseau.");
    } finally {
      setEmailLoading(false);
    }
  };

  return (
    <div className="page">
      <div className="top-buttons">

          <div
      className="header-user"
      onClick={(e) => {
        e.stopPropagation();
        setShowUserMenu(!showUserMenu);
      }}
    >
      <div className="header-avatar">
        {getUsername().charAt(0).toUpperCase()}
      </div>

      {showUserMenu && (
        <div className="user-dropdown">
          <div className="user-email-box">
            {getUsername()}
          </div>

          <button
            className="user-dropdown-item logout-item"
            onClick={handleLogout}
          >
            Se déconnecter
          </button>

        </div>
      )}
    </div>
        <button className="btn-historique" onClick={() => navigate("/historique")}>📋 Historique</button>
      </div>

      <h1 className="title">Créer un accès Wifi</h1>
      <p className="TextGris"> Configurez les paramètres d'accès temporaire pour vos visiteurs ou collaborateurs externes</p>
    
    <div className="box">

  <p className="box-title">Informations de l'utilisateur</p>

    {/* First name + Last name side by side */}
    <div className="name-row">
      <div className="name-field">
        <label className="field-label">Prénom</label>
        <input type="text" className="field-input" placeholder="Jean" value={prenom}
          onChange={(e) => setPrenom(e.target.value)} />
      </div>

      <div className="name-field">
        <label className="field-label">Nom</label>
        <input type="text" className="field-input" placeholder="Dupont" value={nom}
          onChange = {(e) => setNom(e.target.value)} />
      </div>
  </div>

  {sites.length > 1 && (
        <div className="form-group">
          <label className="field-label">Emplacement (Site)</label>
          <select
            className="field-input-emplacement"
            value={selectedSite}
            onChange={(e) => setSelectedSite(e.target.value)}
            required
          >
            <option value="">-- Sélectionner un emplacement --</option>
            {sites.map((site) => (
              <option key={site.id} value={site.id}>
                {site.label}
              </option>
            ))}
          </select>
        </div>
      )}
    

    {/* Quantité + Durée côte à côte */}
      <div className="name-row">
        <div className="name-field">
          <label className="field-label">Nombre d'accès Wifi</label>
          <div className="duree-wrapper" style={{marginBottom: 0}}>
            <input type="number" min="1" max="20" className="field-input" value={quantite}
              onChange={(e) => setQuantite(e.target.value)} />
          </div>
        </div>
        <div className="name-field">
          <label className="field-label">Durée accès Wifi (jours)</label>
          <div className="duree-wrapper" style={{marginBottom: 0}}>
            <span className="duree-icon">🗓️</span>
            <input type="number" min="1" className="field-input" style={{paddingLeft: "36px"}} value={duree}
              onChange={(e) => setDuree(e.target.value)} />
          </div>
        </div>
      </div>

  <button className="btn-generate" onClick={handleSubmit} disabled={loading}>
    {loading ? "⏳ Génération..." : <><span>🗝️</span> Générer un accès Wifi</>}
  </button>  

      <div className="help-container">
        <button className="help-button-rect" onClick={() => setShowHelp(!showHelp)} title="Mode d'emploi">
          <span>💡</span> Besoin d'aide ?
        </button>

        {showHelp && (
          <div className="help-popup">
            <h4>Comment générer un accès ?</h4>
            <ul>
              <li>Saisissez le <strong>Nom</strong> et le <strong>Prénom</strong> du visiteur.</li>
              <li>Sélectionnez son <strong>Emplacement (Site)</strong> si le choix est disponible.</li>
              <li>Indiquez le <strong>Nombre d'accès</strong> à générer (1 à 20).</li>
              <li>Indiquez la <strong>Durée</strong> de validité du code d'accès wifi en jours.</li>
              <li>Cliquez sur le bouton violet pour <strong> générer le code.</strong></li>
              <li>
                Une fois le code généré, vous avez la possibilité :
                <ul className="help-sub-list">
                  <li> - d'<strong> imprimer</strong> le code d'accès afin de le donner à votre visiteur</li>
                  <li> - de <strong> recevoir</strong> le code d'accès par mail  </li>
                  <li> - d'inserer le  <strong> mail du visiteur</strong> pour lui envoyer le code d'accés  </li>

                </ul>
              </li>
            </ul>
          </div>
        )}
      </div>
  
</div>


      {/* MODAL */}
{voucher && (
  <div
    className="modal-overlay"
    onClick={(e) => {
      if (e.target === e.currentTarget) {
        setVoucher(null);
        setEmailVisiteur(""); 
        setEmailSent(false);  
      }
    }}
  >
    <div className="wifi-modal">
      <button 
        className="modal-close-cross" 
        onClick={() => {
          setVoucher(null);
          setEmailVisiteur(""); 
          setEmailSent(false);   
        }} 
        title="Fermer"
      >
        <RxCross1 size={18} />
      </button>

      {/* Header */}
      <div className="wifi-modal-header">
        <div className="wifi-icon">📶</div>

        <div>
          <p className="wifi-title">Accès Wifi</p>
          <p className="wifi-subtitle">
            Accès généré avec succès
          </p>
        </div>
      </div>

      {/* Body */}
      <div className="wifi-modal-body">

        <div className="beneficiaire-block">
          <span className="beneficiaire-label">
            BÉNÉFICIAIRE
          </span>

          <h2 className="beneficiaire-name">
            {voucher.prenom} {voucher.nom}
          </h2>

          <p className="beneficiaire-text">
            L'accès au réseau a été configuré avec succès
            pour cet utilisateur.
          </p>
        </div>

        {/* Clé(s) Wifi */}
      <div className="wifi-code-box">
        <p className="wifi-code-label">
          {voucher.quantite > 1 ? `Vos ${voucher.quantite} accès Wifi :` : "Voici votre accès Wifi :"}
        </p>
        {voucher.cles && voucher.cles.map((cle, i) => (
          <div key={i} className="wifi-code" style={voucher.quantite > 1 ? {fontSize: "32px", marginBottom: "10px"} : {}}>
            {cle}
          </div>
        ))}
      </div>
        
        {/* Expiration */}
        <div className="wifi-expiration">
          ⏰ Cet accès sera valable{" "}
          <strong>{voucher.duree} jour(s)</strong>
          à partir de la première connexion.
          S'il n'est pas utilisé, il sera révoqué automatiquement après 30 jours.
        </div>

        <div style={{ marginTop: '20px', padding: '0 20px' }}>
          <label style={{ display: 'block', fontSize: '13px', fontWeight: '500', color: '#555', marginBottom: '5px', textAlign: 'left' }}>
            ✉️ Envoyer également au visiteur (Optionnel) :
          </label>
          <input 
            type="email" 
            placeholder="Ex: visiteur@gmail.com"
            value={emailVisiteur}
            onChange={(e) => setEmailVisiteur(e.target.value)}
            style={{
              width: '100%',
              padding: '10px',
              borderRadius: '6px',
              border: '1px solid #ccc',
              fontSize: '14px',
              boxSizing: 'border-box'
            }}
          />
        </div>

      </div>

      {/* Footer */}
      <div className="wifi-modal-footer" style={{ flexDirection: 'column', gap: '10px' }}>
        
        <div style={{ display: 'flex', width: '100%', gap: '12px' }}>
          <button
            className="wifi-btn-outline"
            onClick={handleSendEmail}
            disabled={emailLoading || emailSent}
            style={{ flex: 1 }}
          >
            {emailLoading
              ? "Envoi en cours..."
              : emailSent
              ? "✓ Envoyé avec succès !"
              : emailVisiteur.trim() !== ""
              ? `✉️ Envoyer au visiteur + moi`
              : "✉️ S'envoyer le mail (Moi uniquement)"}
          </button>

          {/* Bouton imprimer */}
          <button
            className="wifi-btn-primary"
            onClick={() => window.print()}
            style={{ flex: 1 }}
          >
            🖨️ Imprimer le code
          </button>
        </div>

        <p style={{ fontSize: '11px', color: '#777', margin: '0', textAlign: 'center' }}>
          {emailVisiteur.trim() !== "" 
            ? "Le visiteur recevra sa clé. Vous recevrez automatiquement une copie conforme."
            : "Laissez le champ email vide au-dessus si vous souhaitez uniquement recevoir le récapitulatif sur votre boîte."}
        </p>
      </div>


    </div>
  </div>
)}

    </div>
  );

}
export default WifiForm;